var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L0 6m0-6l6 6",
    strokeWidth: 0.75
  })));
}

export default __webpack_public_path__ + "299d4163fdbc30c0982ab1f2d187515d.svg";
export { SvgCloseWhite as ReactComponent };